module.exports = __webpack_public_path__ + "985d81b9ad2699a47d783feb5cfe8f30.png";